import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { keys } from "../queryKeys.js";
import * as api from "../api/statusPages.js";

export function useStatusPages(options = {}) {
  return useQuery({
    queryKey: keys.statusPages.list,
    queryFn: api.fetchStatusPages,
    ...options,
  });
}

export function useStatusPage(id, options = {}) {
  return useQuery({
    queryKey: keys.statusPages.detail(id),
    queryFn: () => api.fetchStatusPage(id),
    enabled: !!id,
    ...options,
  });
}

export function useStatusPageSubscribers(id, options = {}) {
  return useQuery({
    queryKey: keys.statusPages.subscribers(id),
    queryFn: () => api.fetchStatusPageSubscribers(id),
    enabled: !!id,
    ...options,
  });
}

export function useCreateStatusPage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.createStatusPage,
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.statusPages.all }),
  });
}

export function useUpdateStatusPage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => api.updateStatusPage(id, data),
    onSuccess: (_d, { id }) => {
      qc.invalidateQueries({ queryKey: keys.statusPages.all });
      qc.invalidateQueries({ queryKey: keys.statusPages.detail(id) });
    },
  });
}

export function useCreateStatusPageMessage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ statusPageId, data }) =>
      api.createStatusPageMessage(statusPageId, data),
    onSuccess: (_d, { statusPageId }) => {
      qc.invalidateQueries({ queryKey: keys.statusPages.detail(statusPageId) });
      qc.invalidateQueries({ queryKey: keys.statusPages.messages(statusPageId) });
    },
  });
}

export function useUpdateStatusPageMessage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ statusPageId, messageId, data }) =>
      api.updateStatusPageMessage(statusPageId, messageId, data),
    onSuccess: (_d, { statusPageId }) => {
      qc.invalidateQueries({ queryKey: keys.statusPages.detail(statusPageId) });
      qc.invalidateQueries({ queryKey: keys.statusPages.messages(statusPageId) });
    },
  });
}
